var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 12.5C25.5 19.4038 19.9038 25 13 25C6.09615 25 0.5 19.4038 0.5 12.5C0.5 5.59615 6.09615 0 13 0C13.3269 0 13.6731 0.0192096 14 0.0384404C20.0961 0.51921 24.9808 5.40387 25.4616 11.5C25.4808 11.8269 25.5 12.1731 25.5 12.5Z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 15.1L15.7 18.6L18.5 15.1H16.4007V6H15.0007V15.1H12.9ZM10.8 20V10.9H12.9L10.1 7.4L7.3 10.9H9.4L9.4 20H10.8Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.370f64e93c9a3f483276786ac9811e64.svg";
export { ForwardRef as ReactComponent };